<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="card-title">Datos del campamento</h4>
        </div>

        <form class="md-layout-item" id="camp_form" @submit.prevent="saveCamp()">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('name')">
                <label for="name">Nombre</label>
                <md-input
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  v-model="updatedCamp.name"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('residentId')">
                <label for="residentId">Residente</label>
                <md-select
                  data-vv-name="residentId"
                  v-validate="modelValidations.residentId"
                  v-model="updatedCamp.residentId"
                  name="highway_company"
                >
                  <md-option
                    v-for="resident in residents"
                    :value="resident.id"
                    :key="resident.id"
                  >{{ resident.name }}</md-option>
                </md-select>
                <error-indicator :valid="validField('residentId')"></error-indicator>
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-100">
              <md-field :class="validationClass('address')">
                <label>Dirección</label>
                <md-textarea
                  data-vv-name="address"
                  v-validate="modelValidations.address"
                  v-model="updatedCamp.address"
                ></md-textarea>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-medium-size-100">
              <md-field :class="validationClass('state')">
                <label for="state">Estado</label>
                <md-select
                  data-vv-name="state"
                  v-validate="modelValidations.state"
                  v-model="updatedCamp.state"
                  name="state"
                >
                  <md-option
                    v-for="state in states"
                    :value="state.id"
                    :key="state.id"
                  >{{ state.name }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-50 md-medium-size-100">
              <md-field :class="validationClass('municipality')">
                <label for="municipality">Municipio</label>
                <md-select
                  data-vv-name="municipality"
                  v-validate="modelValidations.municipality"
                  v-model="updatedCamp.municipality"
                  name="municipality"
                >
                  <md-option
                    v-for="municipality in municipalities"
                    :value="municipality.id"
                    :key="municipality.id"
                  >{{ municipality.name }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('distanceToExit')">
                <label>Distancia a la salida</label>
                <md-input
                  type="decimal"
                  data-vv-name="distanceToExit"
                  v-validate="modelValidations.distanceToExit"
                  v-model="updatedCamp.distanceToExit"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('highwayKm')">
                <label>KM en el que desemboca</label>
                <md-input
                  type="decimal"
                  data-vv-name="highwayKm"
                  v-validate="modelValidations.highwayKm"
                  v-model="updatedCamp.highwayKm"
                ></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout" v-if="!this.edit">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-checkbox v-model="updatedCamp.confirmed">Crear almacén</md-checkbox>
            </div>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="camp_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import { mapState } from "vuex";
import { ImageField } from "@/components";
import catalogService from "@/services/catalog";
import userService from "@/services/user";

const modelValidations = {
  name: {
    required: true,
  },
  residentId: {
    required: true,
  },
  state: {
    required: true,
  },
  municipality: {
    required: true,
  },
  address: {
    required: true,
  },
  highwayKm: {
    required: true,
  },
  distanceToExit: {
    required: true,
  },
};

export default {
  name: "EditCamp",

  components: {
    ImageField,
  },

  props: {
    camp: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "Editar campamento",
    },
    edit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      confirmed: true,
      residents: [],
      municipalities: [],
      updatedCamp: { ...this.camp, confirmed: true },
      modelValidations,
      touched: {
        name: false,
        codename: false,
      },
    };
  },

  methods: {
    updateMunicipality() {
      if (!this.updatedCamp.state) return;

      catalogService
        .fetch("common/states", this.updatedCamp.state)
        .then((data) => {
          this.municipalities = data.Municipality;
        });
    },
    saveCamp() {
      const { residentChanged } = this;
      const payload = {
        original: this.camp,
        updated: this.updatedCamp,
        residentChanged,
      };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", payload);
        }
      });
    },
  },
  created() {
    this.updateMunicipality();
  },
  mounted() {
    this.watchTouched({ updatedCamp: Object.keys(modelValidations) });
    userService
      .fetchType("revi")
      .then((residents) => (this.residents = residents));
  },
  computed: {
    ...mapState("catalogs", {
      states: (s) => s["common/states"],
    }),
    residentChanged() {
      const { residentId: currentResident } = this.camp;
      const { residentId: updatedResident } = this.updatedCamp;

      return currentResident != updatedResident;
    },
  },
  watch: {
    camp(value = {}) {
      this.updatedCamp = { ...value };
    },
    "updatedCamp.state": function () {
      this.touched.state = true;

      this.updateMunicipality();
    },
    residentChanged: function (val, oldVal) {
      const residentName = this.camp.resident.user.name;

      if (val) {
        this.$confirmMessage(
          {
            title: "Cambio de Residente",
            html: `Se reasignara el residente de los siniestros activos de <strong> ${residentName} </strong> en este campamento.`,
          },
          () => {
            this.updatedCamp.residentId = this.camp.residentId;
          }
        );
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Camp/Edit.vue